function checkValidCellphoneCode(phoneCode: string) {
  switch (phoneCode) {
    //you have constants, use them :)
    case "050":
      return true;
    case "051":
      return true;
    case "052":
      return true;
    case "053":
      return true;
    case "054":
      return true;
    case "055":
      return true;
    case "056":
      return true;
    case "058":
      return true;
    case "059":
      return true;
    default:
      return false;
  }
}

export default checkValidCellphoneCode;
